import Loadable from '@app/utils/Loadable';
import validationSystemServices from '@mortee/services/validationSystemServices';
import useLoadable from '@app/hooks/loadable/useLoadable';
import { useDebounce } from '@app/hooks/useDebounce';

export default function useBankNameByCountryCodeAndBankCode(
  countryCode: string | undefined,
  bankCode: string | undefined,
): Loadable<string | null> {
  const debouncedCountryCode = useDebounce(countryCode?.toUpperCase(), 400);
  const debouncedBankCode = useDebounce(bankCode?.toUpperCase(), 400);

  const [result] = useLoadable(async () => {
    if (!debouncedCountryCode || !debouncedBankCode) {
      return null;
    }

    // A country + bank code with no DB match returns 404 (notification already suppressed by the
    // service). Swallow it and return null — "no bank name" is a normal outcome, not an error to
    // surface; uncaught, the rejection bubbles up as an "Uncaught (in promise)" per unmatched code.
    try {
      return await validationSystemServices.getBankNameByCountryCodeAndBankCode(debouncedCountryCode, debouncedBankCode);
    } catch {
      return null;
    }
  }, [debouncedBankCode, debouncedCountryCode]);

  return result;
}
